export default class CommandArg
{
	remoteClass = "gongqi.erp.gotmodel.form.remote.CommandArg"
	mapGroups;
	mapEditors;
	joinGroup;
	
	defaultGroupAlias;
	argObject;
	formParam;
	
	contextMap;
}



// WEBPACK FOOTER //
// ./src/forms/sys/remote/CommandArg.js